module.exports = __webpack_public_path__ + "img/T74.4bcb8d09.jpg";